<div class="container-fluid">
    <div>
      <app-cities-header (searchByName)="searchCityByName($event)" [tableSettings]="tableSetting.columns"></app-cities-header>
    </div>
    <div class="mt-2">
      <table class="table">
        <thead>
          <tr>
            <td class="w-20" *ngFor="let column of tableSetting.columns;let i = index">
              <div *ngIf="column.isSortable">
  
                <span class="columheader" style="cursor:pointer">{{column.title}}</span>
                <span class="icon-ic_filtered column-filter-icon cursor-pointer" (click)="showSortingPopup(column)" *ngIf="column.isFilterIcon"></span>
  
              </div>
              <div *ngIf="!column.isSortable">
                <span class="columheader">{{column.title}}</span>
              </div>
              <div class="resource-dropdown" *ngIf="column.displaysort">
                <app-cities-filter [cityArray]="cityArray" [statusArray]="statusArray" [column]="column" [tableSettings]="tableSetting" (gridFiltersApplied)="checkFilterApplied($event)"></app-cities-filter>
              </div>
            </td>
          </tr>
        </thead>
        <tbody class="results-list-panel" (click)="hideDropdowns()">
          <div class="no-search-results" *ngIf="((usersList!=null)&&(usersList.length==0))">
            <span class="icon-ic_Search_NEG_circle"></span>
            <label>No results found</label>
          </div>
  
          <tr *ngFor="let city of usersList | paginate: { itemsPerPage: 10, currentPage: p, totalItems: totalCount};let i = index">
            <td>
              <span class="showellipsis" tooltip={{city.cityName}}>{{city.cityName}}</span>
            </td>
            <td>
              <span class="showellipsis" tooltip={{city.countryName}}>{{city.countryName}}</span>
            </td>
            <td>
              <span class="showellipsis" class="text-truncate" tooltip="{{city.DateAdded | date:'d/MMM/y, h:mm a'}}">{{city.dateAdded | date:'d/MMM/y, h:mm a'}}</span>
            </td>
            <td>
              <span class="showellipsis" class="text-truncate" tooltip={{city.AddedBy}}>{{city.addedBy}}</span>
            </td>
  
            <!-- <td>
              <span class="circle" [ngClass]="{'bg-red': !city.isActive,'bg-green': city.isActive}"></span>
              <span class="showellipsis" tooltip={{city.isActive}}>{{city.isActive ? 'Active'  :'InActive' }}</span>
            </td> -->

            <td>
              <span class="circle" [ngClass]="{'bg-red': !city.isActive,'bg-green': city.isActive}"></span>
              <span class="showellipsis" >{{city.isActive ? 'Active' : 'Inactive'}}</span>                  
          </td>
            <td>
            </td>
            <td class="d-flex justify-content-end">
              <i class="icon-ic_edit px-2" (click)="showEditData(city)" style="cursor: pointer;"></i>
              <i class="icon-ic_delete px-2" (click)="deleteCity(city.cityID,city)" style="cursor: pointer;"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  <div class="paginationwithcount" *ngIf="((usersList!=null)&&(usersList.length>0))" (click)="hideDropdowns()">
    <span class="mb-4 mx-4">Page</span>
    <pagination 
                [(ngModel)]="filterData.page"
                [boundaryLinks]="true" 
                (pageChanged)="changeCurrentPage($event);p = $event"
                [(totalItems)] = "totalCount"
                [maxSize]="5"
                firstText="&shy;"
                lastText="&shy;"
                previousText="&shy;"
                nextText="&shy;"
                [rotate]="false"
                [itemsPerPage] = "itemsperPage"
                >
    </pagination>  
</div>
<div class="totalcount" *ngIf="((usersList!=null)&&(usersList.length>0))"><span>{{((filterData.page -1) * itemsperPage )+ 1}} - {{ countLength }} of <b>{{totalCount}}</b></span></div>
  
</div>
  
  
  
  
